const tokenKey = 'authtoken';

export const getValue = key => window.localStorage.getItem(key);

export const setValue = (key, value) => {
  window.localStorage.setItem(key, value);
};

export const getJsonValue = key => {
  const value = getValue(key);
  if (value) {
    try {
      return JSON.parse(value);
    } catch {
      console.warn(
        `Unable to read from browser local storage. A value (key: ${key}) is not in JSON format`,
        value
      );
    }
  }
  return null;
};

export const setJsonValue = (key, value) => {
  let encoded;

  try {
    encoded = JSON.stringify(value);
  } catch (err) {
    console.error(
      `Unable to save in browser local storage. A value (key: ${key}) is not a JSON format key: `,
      encoded
    );
    throw err;
  }

  setValue(encoded);
};

export const clearStorage = () => {
  localStorage.clear();
};

export const getMsalIdToken = () => getValue(tokenKey);
